var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.screenType === 'desktop')?_c('login-desktop'):_vm._e(),(_vm.screenType === 'mobile')?_c('login-mobile'):_vm._e(),(_vm.screenType === 'tablet')?_c('login-tablet'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }